import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { slice as activitiesSlice } from '../../apps/activities/slice'
import listenToSelector from '../../util/listen_to_selector'
import initOffice from './microsoft/office_init'

let officeModel

async function setInitialPageFromSlideData () {
  if (officeModel.has('url')) {
    const url = officeModel.get('url')
    const re = /([a-z_]+)\/([A-Za-z0-9]+)/
    const [, type, key] = re.exec(url)

    console.log(`initialized with pre-set activity ${type}/${key}`)
    store.dispatch(appSlice.pageUpdated('activities'))

    const page = officeModel.isPresenting() && officeModel.isVisible() ? 'present' : 'activity'
    await store.dispatch(activitiesSlice.loadActivity({
      type,
      key,
      page
    }))
  }
}

function pageOrVisibilityChanged () {
  const reduxState = store.getState()

  if (officeModel.isPresenting() && officeModel.isVisible()) {
    const activityModel = activitiesSlice.selectActivityAsModel(reduxState)
    if (activityModel.id > 0) {
      console.log('>>> activating')
      activityModel.activate()
      store.dispatch(activitiesSlice.pageUpdated('present'))
    }
  }
}

function setInitialState () {
  const { ready } = store.getState()[appSlice.name]

  if (ready) {
    setInitialPageFromSlideData()
  } else {
    listenToSelector((state) => state[appSlice.name].ready, (ready) => {
      ready && setInitialPageFromSlideData()
    })
  }
}

export default async (app) => {
  const { role } = store.getState()[appSlice.name]

  if (role !== 'agave') {
    return
  }

  // If agave initialization race conditions become frequent,
  // move this into entry/agave.js
  console.log('initializing office')
  officeModel = await initOffice()

  if (!officeModel) {
    return
  }

  console.log('office initilization complete')

  setInitialState()

  listenToSelector((state) => state[appSlice.name].page, pageOrVisibilityChanged)
  listenToSelector((state) => state[activitiesSlice.name].page, (page) => {
    pageOrVisibilityChanged()
  })

  officeModel.on('change:visibility', () => {
    console.log('visibility changed', officeModel.isVisible())
    pageOrVisibilityChanged()
  })

  officeModel.on('change:activeView', () => {
    const isPresenting = officeModel.isPresenting()
    let page = store.getState()[appSlice.name].page
    console.log('active view changed', isPresenting, page)

    if (page !== 'activities') {
      console.log(`presenting event ignored due to page = ${page}`)
      return
    }

    const { activity } = store.getState()[activitiesSlice.name]
    if (activity && isPresenting) {
      page = 'present'
    } else if (activity) {
      page = 'activity'
    } else {
      page = 'activities'
    }

    // Switch between present & activity if not on activities list
    store.dispatch(activitiesSlice.pageUpdated(page))
  })

  // save activity
  listenToSelector((state) => {
    const activity = state[activitiesSlice.name].activity
    return {
      type: activity?.type,
      key: activity?.shared_key
    }
  }, ({ type, key }) => {
    if (!officeModel) {
      console.log('[ERROR] office model not yet setup')
      return
    }

    console.log('saving activity', type, key)
    if (type && key) {
      officeModel.saveActivity(type, key)
    } else {
      officeModel.clearActivity()
    }
  }, (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b)
  })
}
